<div [ngClass]="{'component-style': useComponentStyle}">
  <form [formGroup]='formGroup' class='input-password'>
    <div [ngClass]="{'label-with-info': help && label}">
      <pt-input-label
        *ngIf='label'
        [inputId]='inputId'
        [isRequired]='isRequired'
        [label]='label'
        [showRequiredSign]='showRequiredSign'
        style='display: contents'
      ></pt-input-label>

      <pt-icon
        *ngIf='help && label'
        [iconType]='iconType'
        [key]='iconKey'
        [ngbTooltip]='passwordHelp'
        placement='right'
        tooltipClass='input-password-help-tooltip'
        triggers='click'
      ></pt-icon>
    </div>
    <div class='input-group input-group-sm h-25px'>
      <input
        [class.is-invalid]='formGroup.get("password").hasError("invalidAsync") || formGroup.invalid'
        [class.ng-invalid]='formGroup.get("password").hasError("invalidAsync") || formGroup.invalid'
        [id]='inputId'
        [type]='passwordInputState.inputType'
        autocomplete='new-password'
        data-testid="password"
        class='flex-grow-1 form-control form-control-sm h-25px'
        formControlName='password'>
      <div class='input-group-text p-0 h-25px'>
        <button
          [disabled]="isDisabled"
          (click)='passwordInputState.toggle()'
          class='btn btn-sm btn-outline-secondary d-flex justify-content-center align-items-center border-0 h-25px'
          type='button'>
          <pt-icon [key]='passwordInputState?.iconType?.toString()'></pt-icon>
        </button>
      </div>
      <div class='input-group-text p-0 h-25px'>

        <button
          (click)='generatePassword()'
          [disabled]="isDisabled"
          *ngIf='generateEnabled'
          class='btn btn-outline-secondary d-flex justify-content-center align-items-center h-100 border-0 h-25px'
          type='button'>
          {{ 'BUTTON.GENERATE' | translate }}
        </button>
      </div>
      <pt-icon
        *ngIf='help && !label'
        [iconType]='iconType'
        [key]='iconKey'
        [ngbTooltip]='passwordHelp'
        class='info-without-label'
        placement='right'
        tooltipClass='input-password-help-tooltip'
        triggers='click'
      ></pt-icon>
    </div>
  </form>
</div>

<ng-template #passwordHelp>
  <pt-input-password-help [passwordHelpParams]='passwordParamsResponse'></pt-input-password-help>
</ng-template>



